var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doctor-box"},_vm._l((_vm.doctorList),function(doctor){return _c('doctor',{key:doctor.id,attrs:{"doctor":doctor},on:{"select":_vm.doctorSelect}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }